import gql from "graphql-tag";

export const HOME_QUERY = gql`
  query home {
    home {
      competition {
        competitionActive
        signUpPageText
        homepageText
        referAFriendText
        competitionTermsAndConditionsCheckboxText
        willReadyMessage
        competitionReferrals {
          id
          referralText
        }
      }
      omOnlyExecutor
    }
  }
`;
